import { render, staticRenderFns } from "./activeInfo.vue?vue&type=template&id=bd93ef4a&scoped=true"
import script from "./activeInfo.vue?vue&type=script&lang=js"
export * from "./activeInfo.vue?vue&type=script&lang=js"
import style0 from "./activeInfo.vue?vue&type=style&index=0&id=bd93ef4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd93ef4a",
  null
  
)

export default component.exports